import React, { useEffect, useState } from 'react';
import {
	Slider,
	Button,
	DateRangePicker,
    Input
} from '@kaleyra/emmy';
import Styles from '../../CallbackProfiles/CallbackProfile.module.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import moment from 'moment';

export type MapStateToPropsType = {
	params: any;
};

export type MapDispatchToPropsType = {
	closeFilterModal: () => void;
	applyFilters: (filters: any) => void;
};

const FilterModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = ({
	closeFilterModal,
	params,
	applyFilters,
}) => {
    const [date, setDate] = useState<any>(null);
	const [status_code, setstatusCode] = useState<string>('');
	const { dateTag, setDateTag, status_codeTag, setstatusCodeTag} = params;
	const { t } = useTranslation();

	useEffect(() => {
		if (dateTag) {
			setDate(dateTag);
		}
        if(status_codeTag){
            setstatusCode(status_codeTag)
        }
	}, []);

	const disabledDate = (current: any) => {
		// Can not select days after today
		return current && current > moment().endOf('day');
	};

	const handleSave = () => {
		// applyFilters
		let filters: any = {};

        if (date) {
			filters.start_date = moment(date[0]).format('YYYY-MM-DD');
			filters.end_date = moment(date[1]).format('YYYY-MM-DD');
		}
        if(status_code){
            filters.response_code  = status_code;
        }
		applyFilters(filters);

		// set the tags
		setDateTag(date);
        setstatusCodeTag(status_code);
		closeFilterModal();
	};


	const disableApply = (): boolean => {	
		if (date && (date.length < 2) || (date && date.length === 2 && (date[0]===null || date[1]===null))) return true;
		return false;
	};

	const renderFooter = () => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={() => closeFilterModal()}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					type="primary"
					disabled={disableApply()}
					onClick={handleSave}
				>
					{t('BLD01036')}
				</Button>
			</div>
		);
	};
	const setValue = () =>{
		if(date && date.length){
			return date
		}
		else{
			return undefined
		}
	}
	return (
		<Slider
			title={t('mainFilter')}
			containerId="root-modal"
			onClose={() => closeFilterModal()}
			visibility={true}
			footer={renderFooter()}
		>
			<div className={cn(Styles.filterModal)}>
            	<Input
					value={status_code}
					label={t('responseCode')}
					placeholder={t('responseCode')}
					onChange={(val: any) => setstatusCode(val.target.value)}
					className={cn(Styles.mrgBtm)}
					showBottomLabelSpace={false}
				/>

				<div className={Styles.creratedOnContainer}>
					<div className={Styles.compSubHeader}>
						{t('createdBetween')}
					</div>
					<DateRangePicker
						onOk={(date: any) => setDate(date)}
						inputStyle={Styles.datePickerWrapper}
						value={setValue()}
						onClear={()=>{
							setDate(null)
						}}
						disabledDate={disabledDate}
						okBtnText={t('done')}
						cancelBtnText={t('mainCancel')}
						placeholder={[t('startDate'), t('endDate')]}
					/>
				</div>
			</div>
		</Slider>
	);
};

export default FilterModal;
